/*
 *  Author: DL
 *  Date: 2020-12-07 11:15:43
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-07 11:46:30
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import { createContext } from 'react';

let Context = null;

function _useContext() {
    if (Context) {
        return Context;
    } else {
        Context = createContext({});
        return Context;
    }
}

export default _useContext();
